import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

/**
 * 用户登陆
 */
export const authLogin_API = (params: any) => {
  return axios.post(
    `${ADMIN_API_ROOT}/login/login`,
    params,
    // {
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" }
    // }
  );
};

/**
 * 获取用户信息
 */
export const getAuthInfo_API = () => {
  return axios.get(`${ADMIN_API_ROOT}/index/info`);
};

/**
 * 根据角色查询权限
 */
export const getRoles_API = (id: string) => {
  return axios.get(`${ADMIN_API_ROOT}/admin/roles/${id}`);
};
